import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import VnButton from '@ui/components/VnButton';
import { addOutline } from 'ionicons/icons';
import ModalPopup from '@ui/components/VnModal';
import AddUserForm from './AddUserForm';
import UsersTable from './UsersTable';
import { getAllEmployeesAsync, updateEmployeeStatusAsync } from '@application/features/auth/authThunks';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import VnNotificationModel from '@ui/components/VnNotificationModel';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
const UsersTab = () => {
    const { employee } = useAppSelector((state) => state.auth);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenEmployeeStatusChangePopup, setIsOpenEmployeeStatusChangePopup] = useState(false);
    const [selectedEmployeeStatus, setSelectedEmployeeStatus] = useState({ id: 0, isActive: false });
    const [employeeList, setEmployeeList] = useState([]);
    const dispatch = useAppDispatch();
    const oncloseClicked = () => {
        setIsOpen(false);
    };
    const onAddUserClick = () => {
        setIsOpen(true);
    };
    useEffect(() => {
        setEmployeeList(employee ?? []);
    }, [employee]);
    useEffect(() => {
        dispatch(getAllEmployeesAsync())
            .unwrap()
            .then((res) => {
            setEmployeeList(res);
        });
    }, [dispatch]);
    const onEmployeeStatusChange = (id, checked) => {
        setSelectedEmployeeStatus({ id: id, isActive: checked });
        setIsOpenEmployeeStatusChangePopup(true);
    };
    const onEmployeeStatusChangeCancel = () => {
        setIsOpenEmployeeStatusChangePopup(false);
        setSelectedEmployeeStatus({ id: 0, isActive: false });
    };
    const onEmployeeStatusChangeConfirm = () => {
        dispatch(updateEmployeeStatusAsync(selectedEmployeeStatus))
            .unwrap()
            .then((res) => {
            dispatch(getAllEmployeesAsync())
                .unwrap()
                .then((res) => {
                setEmployeeList(res);
            });
            setIsOpenEmployeeStatusChangePopup(false);
            setSelectedEmployeeStatus({ id: 0, isActive: false });
        })
            .catch((error) => { });
    };
    const searchUserHandler = (searchText) => {
        dispatch(getAllEmployeesAsync())
            .unwrap()
            .then((res) => {
            if (searchText && res) {
                const lowerCaseSearchTerm = searchText.toLowerCase();
                setEmployeeList(res.filter((employee) => Object.values(employee).some((value) => typeof value === 'string' && value.toLowerCase().includes(lowerCaseSearchTerm))));
            }
            else {
                setEmployeeList(res);
            }
        })
            .catch((error) => {
            console.error('Failed to fetch employees:', error);
            setEmployeeList([]);
        });
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' }, children: [_jsx(VnGridHeader, { showSearch: true, onSearch: searchUserHandler }), _jsx("div", { children: _jsx(VnButton, { icon: addOutline, customClassName: 'Vn-save-button ml-2', mode: 'primary', text: 'Nieuwe gebruiker', onClick: onAddUserClick, type: 'button' }) })] }), _jsx("div", { className: 'mt-0', children: _jsx(UsersTable, { userData: employeeList, onEmployeeStatusChange: onEmployeeStatusChange }) }), _jsx(ModalPopup, { title: 'Nieuwe gebruiker', content: _jsx(AddUserForm, { onClose: () => oncloseClicked() }), onOpen: isOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' }), _jsx(VnNotificationModel, { message: 'Weet je zeker dat je de status van deze werknemer wilt wijzigen?', onCancel: onEmployeeStatusChangeCancel, onConfirm: onEmployeeStatusChangeConfirm, onOpen: isOpenEmployeeStatusChangePopup, onCancelShow: true })] }) }));
};
export default UsersTab;
